import { Component, HostListener, Input, OnChanges, ViewChild } from "@angular/core";
import {
    NURSERY_CAROUSEL_SELECTOR
} from "../../../crossconcern/utilities/properties/selector.property";
import { NurseryModel } from "../../../datastore/entities/nursery.model";
import { BaseComponent } from "../../base/base.component";
import { OwlOptions } from "ngx-owl-carousel-o";
import { MAP_ROUTE } from "../../../crossconcern/utilities/properties/routename.property";
import { PromotionModel } from "../../../datastore/entities/promotion.model";
import { CarouselModel } from "../../../crossconcern/models/carousel.model";
import { NURSERIES_PATH, SPHERE_PATH } from "../../../crossconcern/utilities/properties/path.property";

@Component({
    selector: NURSERY_CAROUSEL_SELECTOR,
    templateUrl: "./nurserycarousel.component.html"
})

export class NurseryCarouselComponent extends BaseComponent implements OnChanges {

    @Input() public nurseries: NurseryModel[] = [];
    @Input() public promotions: PromotionModel[] = [];

    public carouselItems: CarouselModel[] = [];

    public customOptions: OwlOptions = {
        autoWidth: true,
        margin: 20,
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        dots: false,
        navSpeed: 700,
        nav: true,
        stagePadding: 30,
        navText : [
            "<i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i>",
            "<i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>"
        ],
        items: 1,
        responsiveRefreshRate: 20,
        responsive: {
            400: {
                items: 1
            },
            740: {
                items: 2
            },
            940: {
                items: 3
            },
            1200: {
                items: 4
            }
        }
    };

    public ngOnChanges() {
        this.carouselItems = [];
        this.promotions.forEach((promotion) => {
            this.carouselItems.push(new CarouselModel(null, promotion));
        });
        this.nurseries.forEach((nursery) => {
            this.carouselItems.push(new CarouselModel(nursery, null));
        });
    }

    @ViewChild("owlElement", null) owlElement;

    @HostListener("window:resize", [
        "$event"
    ])
    onResize(_) {
        /* this.owlElement.carouselService.refresh();
        this.owlElement.carouselService.update();
        */
        this.owlElement.carouselService._invalidated.width = true;
        this.owlElement.carouselService._trigger("refresh.owl.carousel");
        this.owlElement.carouselService.refresh();
    }

    public onNurseryClick(uuid: string) {
        this.goToRouteByName(MAP_ROUTE, { id: uuid });
    }

    public onPromotionClick(promotion: PromotionModel) {
        if (promotion.nurseries && promotion.nurseries.length > 0 && promotion.nurseries[0].nursery
        && promotion.nurseries[0].nursery.promotionPhotosphereUuid) {
            this.appComponent.startLoading();
            window.location.href = NURSERIES_PATH + "/" + SPHERE_PATH + "/" +
                promotion.nurseries[0].nursery.uuid + "?start=" + promotion.nurseries[0].nursery.promotionPhotosphereUuid;
        }
    }
}